<script setup>

import { ref, computed } from 'vue';
import OfferCompareRow from './OfferCompareRow.vue';

const props = defineProps({

    title: {
        type: String,
        required: true
    },

    icon: {
        type: String,
        default: 'fa-list'
    },

    changes: {
        type: Array,
        required: true
    },

    expanded: {
        type: Boolean,
        default: true
    }

});

const isExpanded = ref(props.expanded);

const count = computed(() => props.changes.length);

function toggle() {

    isExpanded.value = !isExpanded.value;

}

</script>

<template>

<div class="card shadow-sm mb-3">

    <div
        class="card-header d-flex justify-content-between align-items-center"
        style="cursor:pointer"
        @click="toggle"
    >

        <div>

            <i
                class="fas me-2"
                :class="icon"
            />

            <strong>{{ title }}</strong>

            <span class="badge bg-primary ms-2">

                {{ count }}

            </span>

        </div>

        <div>

            <i
                class="fas"
                :class="isExpanded
                    ? 'fa-chevron-up'
                    : 'fa-chevron-down'"
            />

        </div>

    </div>

    <transition name="fade">

        <div
            v-show="isExpanded"
            class="card-body p-0"
        >

            <offer-compare-row

                v-for="change in changes"

                :key="change.path"

                :change="change"

            />

        </div>

    </transition>

</div>

</template>

<style scoped>

.fade-enter-active,
.fade-leave-active {

    transition: all .2s;

}

.fade-enter-from,
.fade-leave-to {

    opacity:0;

}

</style>